import {ComponentFactoryResolver, Injectable, Type, ViewContainerRef} from '@angular/core';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {MODAL_DEFAULTS} from 'shared/defaults';
import {IModalComponent} from 'shared/_interface/modal-component.interface';
import {UntilDestroy} from '@ngneat/until-destroy';
import {LoadableComponent} from '../../../layout/src/_interface/loadableComponent';

@UntilDestroy()
@Injectable({
	providedIn: 'root'
})
export class ComponentLoaderService {
	constructor(
		private modal: NgbModal,
		private resolver: ComponentFactoryResolver
	) {}

	importComponent(def: LoadableComponent): Promise<Type<any>> {
		return def?.import && typeof def.import === 'function' ? Promise.resolve(def.import().then(r => r[def.componentName])) :
			Promise.reject('incorrect definition');
	}

	async createComponent(comp: Promise<Type<any>>, view: ViewContainerRef) {
		const factory = this.resolver.resolveComponentFactory(await comp);
		view.clear();
		view.createComponent(factory);
	}

	attachComponent(def: LoadableComponent, view: ViewContainerRef) {
		this.importComponent(def).then(
			comp => this.createComponent(Promise.resolve(comp), view)
		);
	}

	open<T>(payload: T, component: IModalComponent) {
		const modalOpts: NgbModalOptions = {...MODAL_DEFAULTS, size: 'xl', backdrop: true} as NgbModalOptions;
		const compRef = this.modal.open(component, modalOpts);
		const instance = compRef.componentInstance;
		instance.payload = payload;
	}
}

